<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modalChangePassword" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div v-if="errors.valid == false" class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                Ingrese su email
              </h3>

              <div class="flex flex-col px-10 xl:px-0">

                <p class="py-4">
                  <input
                    v-model="user.email"
                    aria-label="email"
                    type="text"
                    placeholder="E-mail"
                    autofocus="autofocus"
                    :class="errors.email != null && !errors.valid ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.email != null && !errors.valid" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.email }}
                  </span>
                </p>           
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="modalChangePassword = false"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>

          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button 
              @click="forgotPassword"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                </path>
              </svg>
              Aceptar
            </button>
          </span>

          <span class="pr-4">
            <div v-if="loading">
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#338BFF">
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)" stroke-width="2">
                            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"/>
                            </path>
                        </g>
                    </g>
                </svg>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div
      class="h-screen bg-right bg-cover pb-14"
      style="background-image:url('bg.svg');"
    >
      <!--Nav-->
      <div class="container w-full p-6 mx-auto">
        <div class="flex items-center justify-between w-full">
          <a
            class="flex items-center text-2xl font-bold text-indigo-400 no-underline hover:no-underline lg:text-2xl"
            href="#"
          >
            <svg 
              class="h-12 pr-2 text-indigo-600 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 22 22"
            >
            <path d="M17.125,1.375H2.875c-0.828,0-1.5,0.672-1.5,1.5v11.25c0,0.828,0.672,1.5,1.5,1.5H7.75v2.25H6.625c-0.207,0-0.375,0.168-0.375,0.375s0.168,0.375,0.375,0.375h6.75c0.207,0,0.375-0.168,0.375-0.375s-0.168-0.375-0.375-0.375H12.25v-2.25h4.875c0.828,0,1.5-0.672,1.5-1.5V2.875C18.625,2.047,17.953,1.375,17.125,1.375z M11.5,17.875h-3v-2.25h3V17.875zM17.875,14.125c0,0.414-0.336,0.75-0.75,0.75H2.875c-0.414,0-0.75-0.336-0.75-0.75v-1.5h15.75V14.125z M17.875,11.875H2.125v-9c0-0.414,0.336-0.75,0.75-0.75h14.25c0.414,0,0.75,0.336,0.75,0.75V11.875z M10,14.125c0.207,0,0.375-0.168,0.375-0.375S10.207,13.375,10,13.375s-0.375,0.168-0.375,0.375S9.793,14.125,10,14.125z"></path>
            </svg>
            <span
              class="ml-2 text-2xl font-extrabold whitespace-no-wrap select-none lg:text-4xl"
              >Happer</span
            >
          </a>
        </div>
      </div>

      <!--Main-->
      <div
        class="container flex flex-col flex-wrap mx-auto md:flex-row"
        @keypress.enter="submit"
      >
        <!--Left Col-->
        <div class="flex flex-col w-full mt-4 xl:w-2/5">
          <h1
            class="text-4xl font-bold leading-tight text-center text-purple-800 xl:text-left"
          >
            Iniciar sesión
          </h1>

          <div v-if="!errors.valid && errors.login" class="block text-sm text-left text-red-600 bg-red-200 border border-red-400 h-12 flex items-center p-4 rounded-sm" role="alert">
            {{ errors.login }}
          </div>

          <div class="flex flex-col px-10 xl:px-1">
            <p class="py-4">
              <input
                v-model="email"
                aria-label="email"
                type="text"
                placeholder="E-mail"
                autofocus="autofocus"
                class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
              />
            </p>

            <p class="py-0">
              <div class="flex flex-wrap items-stretch w-full mb-4">
                <input 
                  v-model="password"
                  aria-label="password"
                  :type="[showPassword ? 'text' : 'password']"
                  placeholder="Contraseña" 
                  class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none border-r-0 px-3 focus:border-blue focus:shadow"
                >
                <div class="flex -mr-px">
                  <span @click="showPassword = !showPassword" class="flex items-center bg-white leading-normal rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap">
                    <svg
                      v-if="!loading"
                      class="w-5 h-5 mr-2 -ml-1 text-white-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                        <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z"></path>
                    </svg>
                    <svg 
                      v-if="loading"
                      class="w-5 h-5 mr-2 -ml-1" viewBox="0 0 38 38" stroke="#338BFF">
                      <g fill="none" fill-rule="evenodd">
                          <g transform="translate(1 1)" stroke-width="2">
                              <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                              <path d="M36 18c0-9.94-8.06-18-18-18">
                                  <animateTransform
                                      attributeName="transform"
                                      type="rotate"
                                      from="0 18 18"
                                      to="360 18 18"
                                      dur="1s"
                                      repeatCount="indefinite"/>
                              </path>
                          </g>
                      </g>
                    </svg>
                  </span>
                </div>	
              </div>
            </p>

            <p class="py-4">
              <button
                @click="submit"
                :disabled="loading || email == '' || password == '' || !validateEmail(email)"
                type="submit"
                :class="[(loading || email == '' || password == '' || !validateEmail(email)) ? 'opacity-50 cursor-not-allowed' : 'hover:bg-indigo-600']"
                class="w-full px-8 py-2 text-xl font-medium text-white bg-indigo-500 rounded xl:w-auto"
              >
                Login
              </button>
            </p>

            <span
              class="cursor-pointer mt-10 text-sm font-semibold text-center text-indigo-500 no-underline xl:text-left xl:mt-px"
              @click="modalChangePassword = true; errors.valid = true"
            >
              ¿Olvidaste tu contraseña?
            </span>
          </div>

          <div
            class="pb-10 mx-auto mt-8 select-none sm:mt-24 md:mt-4 lg:mt-0 lg:mx-8 xl:mx-1"
          >
            <p
              class="mx-auto font-bold text-center text-blue-400 xl:mt-24 lg:mt-2 lg:text-left"
            >
              Descargá la aplicación
            </p>
            <div class="flex justify-center w-full mt-2 md:justify-start">
              <img src="App Store.svg" class="h-12 pr-4 cursor-pointer" />
              <img src="Play Store.svg" class="h-12 cursor-pointer" />
            </div>
          </div>
        </div>

        <!--Right Col-->
        <div class="hidden w-3/5 py-6 select-none xl:block">
          <img class="w-5/6 pt-32 mx-auto lg:mr-0" src="devices.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify';

Vue.use(VueAlertify);

export default {
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      modalChangePassword: false,
      loading: false,
      user: {
        email: ''
      },
      errors: {
        valid: true
      }
    }
  },

  methods: {
    async submit() {
      this.errors.valid = true
      this.loading = true
      try {
        const user = await this.$http.post('/auth/loginw', {
          email: this.email,
          password: this.password,
        })
      
        localStorage.setItem('user', JSON.stringify(user))
        this.$router.push({ name: 'Claims' })
      } catch (error) {
        this.errors.valid = false
        this.errors.login = 'Credenciales Incorrectas'
      } finally {
        this.loading = false
      }
    },
    async forgotPassword() {
      this.errors.valid = true
       
      if (!this.validateEmail(this.user.email)){
        this.errors.email = "Email Inválido!"
        this.errors.valid = false
      } else {
        this.loading = true
        try {
          await this.$http.post(`/auth/forgotPassword`, this.user)
          this.user.email = ''
          this.modalChangePassword = false
          this.$alertify.alert('Password Reseteada', 'Se le ha enviado un email a su casilla de correo con la nueva password!').set({'label': 'Aceptar'});
        } catch (error) {
          this.errors.valid = false
          if (error.response.status == 401){
            this.errors.valid = false
            this.errors.email = "El email ingresado no se encuentra registrado!"
          }
        } finally {
          this.loading = false
        }
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email)
    }
  },
}
</script>
